import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { PartnerCarrierAccountV2 } from '@shipium-corp/shipium-ts-types';

export interface CarrierAccountsModel {
  carrierAccountsMap: Record<string, PartnerCarrierAccountV2>;
  setCarrierAccounts: Action<CarrierAccountsModel, PartnerCarrierAccountV2[]>;
  setCarrierAccount: Action<CarrierAccountsModel, PartnerCarrierAccountV2>;
  fetchCarrierAccountsLoading: boolean;
  setFetchCarrierAccountsLoading: Action<CarrierAccountsModel, boolean>;
  fetchCarrierAccounts: Thunk<CarrierAccountsModel, void, Injections, StoreModel, Promise<void>>;
  fetchCarrierAccountsFailure: Action<CarrierAccountsModel, ApplicationErrorOptions>;
}

export const carrierAccountsModel: CarrierAccountsModel = {
  carrierAccountsMap: {},
  setCarrierAccounts: action((state, carrierAccounts) => {
    const carrierAccountsMap = carrierAccounts.reduce<Record<string, PartnerCarrierAccountV2>>((acc, curr) => {
      acc[curr.carrierAccountId!] = curr;
      return acc;
    }, {});
    state.carrierAccountsMap = carrierAccountsMap;
  }),
  setCarrierAccount: action((state, carrierAccount) => {
    state.carrierAccountsMap[carrierAccount.carrierAccountId!] = carrierAccount;
  }),
  fetchCarrierAccountsLoading: false,
  setFetchCarrierAccountsLoading: action((state, isLoading) => {
    state.fetchCarrierAccountsLoading = isLoading;
  }),
  fetchCarrierAccounts: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchCarrierAccountsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchCarrierAccounts();
      //TODO: fix this
      actions.setCarrierAccounts(response as unknown as PartnerCarrierAccountV2[]);
      actions.setFetchCarrierAccountsLoading(false);
      return response;
    } catch (error) {
      actions.fetchCarrierAccountsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchCarrierAccountsLoading(false);
      return error;
    }
  }),
  fetchCarrierAccountsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default carrierAccountsModel;
